import { Component, forwardRef, inject, signal, WritableSignal } from '@angular/core';
import { LargeFamilyCardItemForm } from '../large-family-card-item.form';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { LargeFamilyCardAppEntityLargeFamilyCardWrite } from '../../../../../../../openapi';
import { LargeFamilyCardItemFormComponent } from '../large-family-card-item-form/large-family-card-item-form.component';
import { ParcelItemFormComponent } from '../../parcels/parcel-item-form/parcel-item-form.component';
import { NgIf } from '@angular/common';
import { LargeFamilyCardsPreviewComponent } from '../large-family-cards-preview/large-family-cards-preview.component';
import { ParcelsPreviewComponent } from '../../parcels/parcels-preview/parcels-preview.component';

@Component({
  selector: 'app-large-family-cards-crud',
  standalone: true,
  imports: [
    LargeFamilyCardItemFormComponent,
    ParcelItemFormComponent,
    NgIf,
    LargeFamilyCardsPreviewComponent,
    ParcelsPreviewComponent
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LargeFamilyCardsCrudComponent),
      multi: true
    },
    LargeFamilyCardItemForm
  ],
  templateUrl: './large-family-cards-crud.component.html'
})
export class LargeFamilyCardsCrudComponent implements ControlValueAccessor {

  public disabled = false;

  public showItemForm = false;

  public currentIndex: number | undefined;

  public itemForm: LargeFamilyCardItemForm = inject(LargeFamilyCardItemForm);

  public onChange: any = () => {
  };

  public onTouch: any = () => {
  };

  public cards: WritableSignal<LargeFamilyCardAppEntityLargeFamilyCardWrite[]> = signal<LargeFamilyCardAppEntityLargeFamilyCardWrite[]>([]);

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  public writeValue(v: LargeFamilyCardAppEntityLargeFamilyCardWrite[]): void {
    this.cards.set(v);
  }

  public onRemoveItem(index: number): void {
    this.cards.update(v => v.filter((_, i) => i !== index));
    this.onChange(this.cards());
  }

  public onCancelItemForm(): void {
    this.showItemForm = false;
    this.currentIndex = undefined;
    this.onChange(this.cards());
  }

  public onSubmitItemForm(value: LargeFamilyCardAppEntityLargeFamilyCardWrite): void {
    if (this.currentIndex !== undefined) {
      this.cards.update((v: LargeFamilyCardAppEntityLargeFamilyCardWrite[]) => {
        let items = [...v];
        if (this.currentIndex !== undefined) {
          items[this.currentIndex] = { ...value };
        }
        return items;
      });
    } else {
      this.cards.update(v => [...v, { ...value }]);
    }
    this.showItemForm = false;
    this.currentIndex = undefined;
    this.onChange(this.cards());
  }
}
